import { Navigate, useLocation } from "react-router-dom";

/** Legacy /register?ref= → mobile login with same query string. */
const RegisterReferralRedirect = () => {
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: "/login", search: location.search }}
      replace
    />
  );
};

export default RegisterReferralRedirect;
